import { render } from "./multipleChoice.vue?vue&type=template&id=21f85296&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=js"
export * from "./multipleChoice.vue?vue&type=script&lang=js"

import "./multipleChoice.vue?vue&type=style&index=0&id=21f85296&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f85296"]])

export default __exports__